import { Navigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { ADMIN, SUPER_ADMIN, USER } from "../../Services/enum";

export const AuthGuard = ({ component, adminProtected }) => {
    const UserData = localStorage.getItem("qtrackuser") && JSON.parse(localStorage.getItem("qtrackuser"))
    const isAuthenticated = UserData?.status 
    const Role = UserData?.user?.Role 
    
    return (
        (isAuthenticated && adminProtected && (Role === ADMIN || Role === SUPER_ADMIN) || isAuthenticated && !adminProtected) 
        ?
         component 
        :
          isAuthenticated && adminProtected && Role === USER
        ? 
          <Navigate to="/" />
        :
          <Navigate to="/Login" />
    )
}

AuthGuard.prototype = {
    component: PropTypes.element,
    adminProtected: PropTypes.bool
}